import { useRouteError, isRouteErrorResponse } from "react-router-dom";

function RootErrorBoundary() {
    let error = useRouteError();
    if (isRouteErrorResponse(error)) {
        return (
            <div className="mx-auto my-20 prose max-w-6xl px-3 prose-darkgreen">
                <h1>
                    {error.status} {error.statusText}
                </h1>
                <p>{error.data}</p>
            </div>
        );
    } else if (error instanceof Error) {
        return (
            <div className="mx-auto my-20 prose max-w-6xl px-3 prose-darkgreen">
                <h1>Error</h1>
                <p>{error.message}</p>
                <p>The stack trace is:</p>
                <pre className="prose max-w-full">{error.stack}</pre>
            </div>
        );
    } else {
        return <h1>Unknown Error</h1>;
    }
}

export default RootErrorBoundary;
